import React from 'react';
import ItemPercentageRender,{ItemPercentageProps} from './ItemPercentageRender';

export const ItemPercentage=({...props}:ItemPercentageProps):JSX.Element=>{
	return <ItemPercentageRender {...props}/>;
};
